import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DocumentationFilledIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DocumentationFilledIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/documentation/filled">
            <g id="Vector">
                <path
                    d="M5.99805 4.02686C4.94605 4.02686 3.93605 4.20686 2.99805 4.53886V18.7889C3.96167 18.4489 4.97621 18.2757 5.99805 18.2769C7.9593 18.2769 9.77431 18.9046 11.2527 19.9696V5.71884C9.72929 4.62103 7.8919 4.02425 5.99805 4.02686Z"
                    fill="currentColor"
                >
                </path>
                <path
                    d="M18.0029 4.03077C19.0549 4.03077 20.0649 4.21077 21.0029 4.54277V18.7928C20.0393 18.4528 19.0248 18.2796 18.0029 18.2808C16.0417 18.2808 14.2267 18.9085 12.7483 19.9735V5.72275C14.2717 4.62494 16.1091 4.02816 18.0029 4.03077Z"
                    fill="currentColor"
                >
                </path>
            </g>
        </g>
    </SvgIcon>
)
